module.exports = __webpack_public_path__ + "00576aa5100d4857e685d9e0e05a7244.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/humble-bundle-no-logo.png
// module id = 387
// module chunks = 0